import React from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Alert from "@mui/material/Alert";
import InfoIcon from "@mui/icons-material/Info";
import { CalcGeneralProps } from "./CalculationMain";
import { MuiTimePicker } from "../framework/muiTimePicker";
import { NumberInput } from "../framework/numberInput";

export const CalcAdditions = ({
    translate,
    handleChange,
    settings,
}: CalcGeneralProps) => {
    const {
        isSundayCalculationOn,
        isSundayEveningCalculationOn,
        isSundayNightCalculationOn,
        isSundayOrHolidaySpecificEveningCalculationOn,
        isSundayOrHolidaySpecificNightCalculationOn,
        sundaySpecificEveningWorkStartTime,
        sundaySpecificEveningWorkEndTime,
        sundaySpecificNightWorkStartTime,
        sundaySpecificNightWorkEndTime,
        isSaturdayCalculationOn,
        isSaturdayEveningCalculationOn,
        isEveningCalculationOn,
        isNightCalculationOn,
        saturdayStartTime,
        saturdayEndTime,
        isGrandHolidayDayCalculationOn,
        dayWorkStartTime,
        eveningWorkStartTime,
        nightWorkStartTime,
        isEveningAndNightAdditionThresholdOn,
        eveningAndNightAdditionThreshold,
        isFixedAdditionOn,
        isVehicleGroupAdditionOn,
    } = settings || {};

    const isAnyEveningOrNightOn =
        isEveningCalculationOn ||
        isNightCalculationOn ||
        isSundayOrHolidaySpecificEveningCalculationOn ||
        isSundayOrHolidaySpecificNightCalculationOn;

    return (
        <Grid2 container direction="column" p={3} spacing={2}>
            <Grid2 container direction="row" spacing={2} flexWrap="nowrap">
                <Grid2
                    container
                    direction="column"
                    spacing={2}
                    flexShrink={0}
                >
                    <Typography variant="h6">
                        {translate("dayAdditions")}
                    </Typography>
                    <Grid2>
                        <label className={"field-width-normal"}>
                            <Checkbox
                                id="SATURDAYWORKON"
                                checked={isSaturdayCalculationOn}
                                onChange={(event) =>
                                    handleChange(
                                        "isSaturdayCalculationOn",
                                        event.target.checked
                                    )
                                }
                            />
                            {translate("SATURDAYWORKON")}
                        </label>
                    </Grid2>
                    {isSaturdayCalculationOn ? (
                        <>
                            <Grid2 xsOffset={2}>
                                <MuiTimePicker
                                    label={translate("SATURDAYWORKSTARTTIME")}
                                    value={saturdayStartTime}
                                    onChange={(newValue) =>
                                        handleChange(
                                            "saturdayStartTime",
                                            newValue
                                        )
                                    }
                                />
                            </Grid2>
                            <Grid2 xsOffset={2}>
                                <MuiTimePicker
                                    label={translate("SATURDAYWORKENDTIME")}
                                    value={saturdayEndTime}
                                    onChange={(newValue) =>
                                        handleChange(
                                            "saturdayEndTime",
                                            newValue
                                        )
                                    }
                                />
                            </Grid2>
                            {isEveningCalculationOn ? (
                                <Grid2 xsOffset={2}>
                                    <label>
                                        <Checkbox
                                            checked={
                                                isSaturdayEveningCalculationOn
                                            }
                                            onChange={(event) =>
                                                handleChange(
                                                    "isSaturdayEveningCalculationOn",
                                                    event.target.checked
                                                )
                                            }
                                        />
                                        {translate(
                                            "saturdayEveningCalculationOn"
                                        )}
                                    </label>
                                </Grid2>
                            ) : null}
                        </>
                    ) : null}
                    <Grid2>
                        <label className={"field-width-normal"}>
                            <Checkbox
                                id="SUNDAYWORKON"
                                checked={isSundayCalculationOn}
                                onChange={(event) =>
                                    handleChange(
                                        "isSundayCalculationOn",
                                        event.target.checked
                                    )
                                }
                            />
                            {translate("SUNDAYWORKON")}
                        </label>
                    </Grid2>
                    <Grid2>
                        <label className={"field-width-normal"}>
                            <Checkbox
                                checked={
                                    isSundayOrHolidaySpecificEveningCalculationOn
                                }
                                onChange={(event) =>
                                    handleChange(
                                        "isSundayOrHolidaySpecificEveningCalculationOn",
                                        event.target.checked
                                    )
                                }
                            />
                            {translate("sundaySpecificEveningCalculationOn")}
                        </label>
                    </Grid2>
                    {isSundayOrHolidaySpecificEveningCalculationOn ? (
                        <>
                            <Grid2 xsOffset={2}>
                                <MuiTimePicker
                                    label={translate(
                                        "sundaySpecificEveningWorkStartTime"
                                    )}
                                    value={sundaySpecificEveningWorkStartTime}
                                    onChange={(newValue) =>
                                        handleChange(
                                            "sundaySpecificEveningWorkStartTime",
                                            newValue
                                        )
                                    }
                                />
                            </Grid2>
                            <Grid2 xsOffset={2}>
                                <MuiTimePicker
                                    label={translate(
                                        "sundaySpecificEveningWorkEndTime"
                                    )}
                                    value={sundaySpecificEveningWorkEndTime}
                                    onChange={(newValue) =>
                                        handleChange(
                                            "sundaySpecificEveningWorkEndTime",
                                            newValue
                                        )
                                    }
                                />
                            </Grid2>
                            {isEveningCalculationOn ? (
                                <Grid2 xsOffset={2}>
                                    <label>
                                        <Checkbox
                                            checked={
                                                isSundayEveningCalculationOn
                                            }
                                            onChange={(event) =>
                                                handleChange(
                                                    "isSundayEveningCalculationOn",
                                                    event.target.checked
                                                )
                                            }
                                        />
                                        {translate(
                                            "sundayEveningCalculationOn"
                                        )}
                                    </label>
                                </Grid2>
                            ) : null}
                        </>
                    ) : null}
                    <Grid2>
                        <label className={"field-width-normal"}>
                            <Checkbox
                                checked={
                                    isSundayOrHolidaySpecificNightCalculationOn
                                }
                                onChange={(event) =>
                                    handleChange(
                                        "isSundayOrHolidaySpecificNightCalculationOn",
                                        event.target.checked
                                    )
                                }
                            />
                            {translate("sundaySpecificNightCalculationOn")}
                        </label>
                    </Grid2>
                    {isSundayOrHolidaySpecificNightCalculationOn ? (
                        <>
                            <Grid2 xsOffset={2}>
                                <MuiTimePicker
                                    label={translate(
                                        "sundaySpecificNightWorkStartTime"
                                    )}
                                    value={sundaySpecificNightWorkStartTime}
                                    onChange={(newValue) =>
                                        handleChange(
                                            "sundaySpecificNightWorkStartTime",
                                            newValue
                                        )
                                    }
                                />
                            </Grid2>
                            <Grid2 xsOffset={2}>
                                <MuiTimePicker
                                    label={translate(
                                        "sundaySpecificNightWorkEndTime"
                                    )}
                                    value={sundaySpecificNightWorkEndTime}
                                    onChange={(newValue) =>
                                        handleChange(
                                            "sundaySpecificNightWorkEndTime",
                                            newValue
                                        )
                                    }
                                />
                            </Grid2>
                            {isNightCalculationOn ? (
                                <Grid2 xsOffset={2}>
                                    <label>
                                        <Checkbox
                                            checked={
                                                isSundayNightCalculationOn
                                            }
                                            onChange={(event) =>
                                                handleChange(
                                                    "isSundayNightCalculationOn",
                                                    event.target.checked
                                                )
                                            }
                                        />
                                        {translate(
                                            "sundayNightCalculationOn"
                                        )}
                                    </label>
                                </Grid2>
                            ) : null}
                        </>
                    ) : null}
                    <Grid2>
                        <label className={"field-width-normal"}>
                            <Checkbox
                                id="GRANDHOLIDAYON"
                                checked={isGrandHolidayDayCalculationOn}
                                onChange={(event) =>
                                    handleChange(
                                        "isGrandHolidayDayCalculationOn",
                                        event.target.checked
                                    )
                                }
                            />
                            {translate("grandHolidays")}
                            <Tooltip
                                title={translate("grandHolidayHelper.day")}
                            >
                                <IconButton disableRipple>
                                    <InfoIcon color="primary" />
                                </IconButton>
                            </Tooltip>
                        </label>
                    </Grid2>
                </Grid2>
                <Grid2
                    container
                    direction="column"
                    spacing={2}
                    marginLeft={5}
                    flexShrink={0}
                >
                    <Typography variant="h6">
                        {translate("otherAdditions")}
                    </Typography>
                    <Grid2>
                        <label className={"field-width-normal"}>
                            <Checkbox
                                id="FIXEDADDITIONON"
                                checked={isFixedAdditionOn}
                                onChange={(event) =>
                                    handleChange(
                                        "isFixedAdditionOn",
                                        event.target.checked
                                    )
                                }
                            />
                            {translate("fixedAddition")}
                            <Tooltip title={translate("fixedAdditionHelp")}>
                                <IconButton disableRipple>
                                    <InfoIcon color="primary" />
                                </IconButton>
                            </Tooltip>
                        </label>
                    </Grid2>
                    <Grid2>
                        <label className={"field-width-normal"}>
                            <Checkbox
                                id="VEHICLEGROUPADDITION"
                                checked={isVehicleGroupAdditionOn}
                                onChange={(event) =>
                                    handleChange(
                                        "isVehicleGroupAdditionOn",
                                        event.target.checked
                                    )
                                }
                            />
                            {translate("fleetGroupAddition")}
                        </label>
                    </Grid2>
                    <Grid2>
                        <label className={"field-width-normal"}>
                            <Checkbox
                                id="EVENINGCALCULATIONON"
                                checked={isEveningCalculationOn}
                                onChange={(event) =>
                                    handleChange(
                                        "isEveningCalculationOn",
                                        event.target.checked
                                    )
                                }
                            />
                            {translate("EVENINGCALCULATIONON")}
                        </label>
                    </Grid2>
                    <Grid2 mb={1}>
                        <label className={"field-width-normal"}>
                            <Checkbox
                                id="NIGHTCALCULATIONISON"
                                checked={isNightCalculationOn}
                                onChange={(event) =>
                                    handleChange(
                                        "isNightCalculationOn",
                                        event.target.checked
                                    )
                                }
                            />
                            {translate("NIGHTCALCULATIONISON")}
                        </label>
                    </Grid2>
                    {isEveningCalculationOn ? (
                        <Grid2>
                            <MuiTimePicker
                                label={translate("EVENINGWORKSTARTTIME")}
                                value={eveningWorkStartTime}
                                onChange={(newValue) =>
                                    handleChange(
                                        "eveningWorkStartTime",
                                        newValue
                                    )
                                }
                            />
                        </Grid2>
                    ) : null}
                    {isEveningCalculationOn || isNightCalculationOn ? (
                        <Grid2>
                            <MuiTimePicker
                                label={[
                                    isEveningCalculationOn
                                        ? translate("EVENINGWORKENDTIME")
                                        : null,
                                    isNightCalculationOn
                                        ? translate("NIGHTWORKSTARTTIME")
                                        : null,
                                ]
                                    .filter(Boolean)
                                    .join(" / ")}
                                value={nightWorkStartTime}
                                onChange={(newValue) =>
                                    handleChange(
                                        "nightWorkStartTime",
                                        newValue
                                    )
                                }
                            />
                        </Grid2>
                    ) : null}
                    {isNightCalculationOn ? (
                        <Grid2>
                            <MuiTimePicker
                                label={translate("DAYWORKSTARTTIME")}
                                value={dayWorkStartTime}
                                onChange={(newValue) =>
                                    handleChange("dayWorkStartTime", newValue)
                                }
                            />
                        </Grid2>
                    ) : null}
                    {isAnyEveningOrNightOn ? (
                        <Grid2 container className="field-width-normal">
                            <Grid2 container alignItems="center">
                                <Grid2 xs={2}>
                                    <Checkbox
                                        id="isEveningAndNightAdditionThresholdOn"
                                        checked={
                                            isEveningAndNightAdditionThresholdOn
                                        }
                                        onClick={() =>
                                            handleChange(
                                                "isEveningAndNightAdditionThresholdOn",
                                                !isEveningAndNightAdditionThresholdOn
                                            )
                                        }
                                    />
                                </Grid2>
                                <Grid2 xs={10}>
                                    <NumberInput
                                        label={translate(
                                            "eveningAndNightThreshold"
                                        )}
                                        onChange={(val) =>
                                            handleChange(
                                                "eveningAndNightAdditionThreshold",
                                                val
                                            )
                                        }
                                        value={
                                            eveningAndNightAdditionThreshold
                                        }
                                        endAdornment="h"
                                        disabled={
                                            !isEveningAndNightAdditionThresholdOn
                                        }
                                    />
                                </Grid2>
                            </Grid2>
                            <Grid2>
                                <Alert
                                    severity="info"
                                    className="field-width-normal"
                                >
                                    {translate(
                                        "eveningAndNightThresholdDescription"
                                    )}
                                </Alert>
                            </Grid2>
                        </Grid2>
                    ) : null}
                </Grid2>
            </Grid2>
        </Grid2>
    );
};
